import { graphql } from 'gatsby';
import React from 'react';

import { TextArrayProps } from '../../page-components/editorial-page-full-width/editorial-page-full-width';
import EditorialFullWidthTextAndImageBlock, {
  FullWidthTextAndImageProps,
} from '../editorial-full-width-text-and-image-block/editorial-full-width-text-and-image-block';

export interface FullWidthColumnProps {
  columnList: FullWidthTextAndImageProps[];
  topBlock?: boolean;
  textItem?: TextArrayProps[];
}

const EditorialFullWidthColumnBlock = ({
  columnList,
  topBlock,
  textItem,
}: FullWidthColumnProps) => {
  return (
    <div
      className={
        'grid grid-cols-1 gap-5 sm:grid-cols-2 ' +
        (topBlock &&
        !columnList[0]?.landscapeImage &&
        !columnList[0]?.portraitImage
          ? 'pt-0 '
          : ' ') +
        (topBlock ? 'sm:pt-5 lg:pt-0 ' : ' ')
      }
    >
      {columnList?.map((block, index) => {
        const {
          body,
          cardLink,
          externalLink,
          portraitImage,
          landscapeImage,
          imageAlignment,
          cardType,
        } = block;
        return (
          <div key={index} className="flex h-full ">
            <EditorialFullWidthTextAndImageBlock
              body={body ? body : undefined}
              cardLink={cardLink ? cardLink : undefined}
              externalLink={externalLink ? externalLink : undefined}
              portraitImage={portraitImage ? portraitImage : undefined}
              landscapeImage={landscapeImage ? landscapeImage : undefined}
              imageAlignment={imageAlignment ? imageAlignment : undefined}
              cardType={cardType ? cardType : undefined}
              textItem={textItem ? textItem[index] : undefined}
              topBlock={topBlock && index === 0 ? true : false}
            />
          </div>
        );
      })}
    </div>
  );
};

export default EditorialFullWidthColumnBlock;

export const query = graphql`
  fragment BlockEditorialFullWidthColumn on ContentfulBlockEditorialFullWidthColumn {
    blocktype: __typename
    columnList {
      ...BlockEditorialFullWidthTextAndImage
    }
  }
`;
